import React, { FC } from 'react';
import { RouteProps, Redirect, Route } from 'react-router-dom';
import Login from 'models/Login';
import { inject, observer } from 'mobx-react';

interface IAuthRouteProps extends RouteProps {
  loginInfo?: Login;
}

const AuthRoute: FC<IAuthRouteProps> = ({loginInfo = new Login(), ...props}) => {
  if (loginInfo.isLogin || window.calibration)
    return <Route {...props} />
  else
    return <Redirect to={'/login'} />
}

export default inject('loginInfo')(observer(AuthRoute));